export interface Profile {
  name?: string;
  picture?: string;
  pictureId?: string;
  email?: string;
  phoneNumber?: string;
  description?: string;
  activeProjectId?: string;
  activeCompanyId?: string;
}

export enum LogMessageType {
  TEXT = 'text',
  PICTURE = 'picture'
}

export enum LogType {
  GENERAL = 'general',
  ACTIVITY = 'activity'
}
export enum LogCategories {
  // the values are formatted like this for backwards compatability
  CHANGES = 'Changes',
  DELAYS = 'Delays/Issues',
  INSPECTIONS = 'Inspections',
  SAFETY = 'Site Safety',
  NOTES = 'Subcontractor Notes',
  TODO = 'To Do List',
  WEATHER = 'Weather',
}
export interface Log {
  _id?: string;
  creatorId: string;
  createdAt: Date;
  lastModified: Date;
  additionalUserIds?: string[];
  assignedActivityUserIds: string[];
  p6ActivityId?: string;
  projectId: string;
  logType: LogType;
  title: string;
  category?: string;
  picture?: string;
  featuredImage?: string;
  archived?: boolean;
}
export interface Calendar {
  exceptionDays: number[],
  workDays: number[],
  dayHrs:number
};

export enum ActivityStatus {
  TK_Complete = 'TK_Complete',
  TK_Active = 'TK_Active',
  TK_NotStart = 'TK_NotStart'
}

export interface FilterCode {
  actv_code_type_id: number,
  actv_short_len: number,
  seq_num: number,
  actv_code_type: string,
  proj_id: number,
  wbs_id: string,
  actv_code_type_scope: string,
};
export interface FilterSubCode {
  actv_code_id: number,
  actv_code_type_id: number,
  parent_actv_code_id: string, // number?
  actv_code_name: string,
  short_name: string,
};
export interface Update {
  _id?: string;
  projectId: string;
  creatorId: string;

  uploadedAt: Date;
  updateStatusLive: boolean; //if update is live
  updateStatus: string;
  projectWbsAccordion:any;
  name: string;
  plannedEndDate: Date;
  dataLookAhead: number;
  ifAutomatedProgress: boolean;
  reminderDate?: Date;
  dataDate: Date;

  projectRow: object;
  projShortName: string;

  totalFloatPermissionMap: {
    [userId: string]: boolean,
  },
  updatePeriodType: string;
  calendars:any;
  selectedActivityCode: FilterCode;
  filteringCodesArray: Array<FilterCode>;
  filteringSubCodesArray: Array<FilterSubCode>;
  filteringActiveSubCodesArray?: Array<FilterSubCode>;
  subCodesByUser: { [userId: string]: FilterSubCode },

  archived?: boolean;
  archivedAt?: Date;
}
export const UpateTypes = ["PERCENT_COMPLETE", "REMAINING_DURATION"];
type datestring = string;
export type ImportedActivityTask = {
  task_id: number,
  proj_id: number,
  wbs_id: number,
  clndr_id: number,
  phys_complete_pct: number,
  rev_fdbk_flag: 'N' | 'Y',
  est_wt: number,
  lock_plan_flag: 'N' | 'Y',
  auto_compute_act_flag: 'N' | 'Y',
  complete_pct_type: string, // example: "CP_Drtn"
  task_type: string, // example: "TT_FinMile"
  duration_type: string, // example: "DT_FixedDrtn"
  status_code: string, // example: "TK_NotStart"
  task_code: string,
  task_name: string,
  rsrc_id: string,
  total_float_hr_cnt: number,
  free_float_hr_cnt: number,
  remain_drtn_hr_cnt: number,
  act_work_qty: number,
  remain_work_qty: number,
  target_work_qty: number,
  target_drtn_hr_cnt: number,
  target_equip_qty: number,
  act_equip_qty: number,
  remain_equip_qty: number,
  cstr_date: string,
  act_start_date: string,
  act_end_date: string,
  late_start_date: datestring,
  late_end_date: datestring,
  expect_end_date:""
  early_start_date: datestring,
  early_end_date: datestring,
  restart_date: datestring,
  reend_date: datestring,
  target_start_date: datestring,
  target_end_date: datestring,
  rem_late_start_date: datestring,
  rem_late_end_date: datestring,
  cstr_type: string,
  priority_type: string, // example: "PT_Normal"
  suspend_date: string,
  resume_date: string,
  float_path: string,
  float_path_order: string,
  guid: string,
  tmpl_guid: string,
  cstr_date2: string,
  cstr_type2: string,
  driving_path_flag: 'N' | 'Y',
  act_this_per_work_qty: number,
  act_this_per_equip_qty: number,
  external_early_start_date: string, // datestring?
  external_late_end_date: string, // datestring?
  create_date: datestring,
  update_date: datestring,
  create_user: string,
  update_user: string,
  location_id: string,
};

type WBSObject = {
  wbs_id?: string,
  parent_wbs_id: string,
  wbs_short_name: string,
};
export interface Activity {
  _id?: string;
  updateId: string;
  projectId: string;
  assignedUserId: string;
  createdAt: Date;
  creatorId: string,
  logId?: string;
  activityStatus: string;
  // TODO - need to add projectId here,
  // update all queries for activities with p6ActivityId
  // to also include the projectId query param (security vulnerability across projects)

  //seen for activity list -- all from p6 task table --display variables from activity objects
  p6ActivityId: void|string; // task_code
  activityName: string; // task_name
  criticality: 'N'|'Y'; // driving_path_flag
  earlyStart: void|Date; // early_start_date
  earlyFinish: void|Date; // early_end_date
  actualStart: void|Date; // act_start_date
  actualFinish: void|Date; // act_end_date
  startDate: void|Date;
  finishDate: void|Date;
  taskType: string,

  //calculated displayed vars
  touchedThisPeriod?: boolean;
  originalDuration: number;
  progressAmount: number;
  totalFloat: number; // can be negative or positive
  remainingDuration: number;
  dayHourCount: number;

  isFlagged?: boolean;

  taskRow: {
    status_code: string;
    task_type: string;
    task_code: string;
    task_name: string;
    driving_path_flag: 'Y' | 'N';
    early_start_date: string;
    early_end_date: string;
    act_start_date: string;
    act_end_date: string;
    total_float_hr_cnt: number; // can be negative or positive
    proj_id: number,
    wbs_id: number,
    clndr_id:number,
    remain_drtn_hr_cnt: number,
    target_drtn_hr_cnt: number,
  };
  tskActRows: Array<{
    task_id: number,
    actv_code_type_id: number,
    actv_code_id: number,
    proj_id: number,
  }>;
  projectWbsRow: WBSObject;

  wbsCode: string;
  wbsShortName: string;
  parentWbsId: void|string;
  wbsObjects: Array<WBSObject>,
}

export interface Project {
  _id?: string;
  name: string;
  projectCode: string;
  // Added on the server which is why they are marked optional
  // even though they're not
  // TODO: split the "ProjectInput" interface out from the project model
  creatorId?: string;
  companyId?: string;

  ntpDate?: Date;
  contractCompletionDate?: Date;

  projectNoticeToProceedDate?: Date;

  memberIds?: string[];
  pmIds?: string[];
  updaterIds?: string[];

  picture?: string;
  lastMessage?: LogMessage;
  createdAt?: Date;
  companyCode?: string;
  pictureId?: string;

  currentUpdateId?: string;
  archivedUpdateIds?: string[];
}

export interface LogMessage {
  _id?: string;
  logId: string;
  senderId: string;
  senderName?: string;
  content: string;
  createdAt: Date;
  type: LogMessageType;
  captionText?: string, // for photo messages
}

export interface User extends Meteor.User {
  profile?: Profile;
  isSuperAdmin?: boolean;
  companyIds?: string[],
}

export interface Picture {
  _id?: string;
  complete?: boolean;
  extension?: string;
  name?: string;
  progress?: number;
  size?: number;
  store?: string;
  token?: string;
  type?: string;
  uploadedAt?: Date;
  uploading?: boolean;
  url?: string;
  userId?: string;
}

export interface Company {
  _id?: string;

  creatorId: string;
  name: string;
  code?: string;

  adminIds: string[];
  memberIds: string[];
  adminName: string;
  adminEmail: string;

  town?: string;
  state?: string;
  country?: string;
  address?: string;
  zipCode?: string;
  phoneNumber?: string;

  projectIds: string[];

  picture?: string;
  pictureId?: string;
}



// WEBPACK FOOTER //
// ./src/api/server/models.ts